module.exports = __webpack_public_path__ + "img/girl_en.9b6a9862.png";